<template>
  <div>
    <div class="no-account-msg">
      <div class="alert" role="alert">
        No active account was found for this email address. <br />
        No problem, let's activate one for you...
      </div>
    </div>

    <div class="create-account-form">
      <div class="form-group">
        <input type="text" name="email" :value="emailToRead" disabled class="acc-email" />
        <div class="other-email">
          <router-link :to="{ name: ROUTES.DIGITAL_EVENT_AUTH_LOGIN }">
            <i class="fa fa-fw fa-arrow-left"></i>&nbsp;Use different email address
          </router-link>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="acc-field" :class="{ 'has-error': validation.hasError('userFirstName') }">
            <input
              type="text"
              v-focus
              name="userFirstName"
              v-model="userFirstName"
              placeholder="First Name"
              class="form-control input-lg"
              tabindex="1"
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="acc-field" :class="{ 'has-error': validation.hasError('userLastName') }">
            <input
              type="text"
              name="userLastName"
              v-model="userLastName"
              placeholder="Last Name"
              class="form-control input-lg"
              tabindex="2"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 text-left">
          <div class="checkbox">
            <label for="creatAccConfirmation">
              <input
                id="creatAccConfirmation"
                type="checkbox"
                name="termsAndConditionsField"
                v-model="termsAndConditions"
                tabindex="3"
              />
              I agree with
              <modal-window-link
                modal-window-name="iframe-modal-window"
                link-text="Terms and Conditions"
                :context="{ url: '../page/terms', title: 'Terms and Conditions' }"
              >
              </modal-window-link>
              &amp;
              <modal-window-link
                modal-window-name="iframe-modal-window"
                link-text="Privacy Policy"
                :context="{ url: '../page/privacy-policy', title: 'Privacy Policy' }"
              >
              </modal-window-link>
            </label>
          </div>
        </div>
      </div>
      <div class="form-group" :class="{ 'has-error': validation.hasError('password') }">
        <div class="input-group acc-field">
          <input
            type="password"
            name="password"
            v-model="password"
            @keypress.enter="createAccount"
            placeholder="Create password"
            class="form-control input-lg"
            tabindex="4"
          />
          <span class="input-group-btn">
            <button class="btn btn-lg btn-primary btn-block" :disabled="!canCreateAccount()" @click="createAccount()">
              <digital-event-preloader type="container" :active="isLoading" />
              <i class="fa fa-fw fa-lg fa-arrow-right"></i>
            </button>
          </span>
        </div>
        <div v-if="!validation.firstError('password')" class="password-min">
          <i class="fa fa-key" aria-hidden="true"></i>
          <!-- eslint-disable-next-line max-len -->
          minimum: 8 characters 1 number 1 uppercase, allowed special characters: !@£$%^&*()_-+=.&gt;&lt;
        </div>
        <div v-else class="form-field-error-message">{{ validation.firstError("password") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixin from "./mixins/AuthMixin";
import SimpleVueValidation from "simple-vue-validator";
import { PASSWORD_VALIDATION } from "@/helpers/constants";
import { mapGetters } from "vuex";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "CreateAccount",
  mixins: [AuthMixin],
  data() {
    return {
      userFirstName: "",
      userLastName: "",
      password: "",
      termsAndConditions: false
    };
  },
  validators: {
    userFirstName(value) {
      return Validator.value(value).required();
    },
    userLastName(value) {
      return Validator.value(value).required();
    },
    password(value) {
      return Validator.value(value)
        .required()
        .minLength(8)
        .regex(PASSWORD_VALIDATION.REGEXP, PASSWORD_VALIDATION.ERROR_MESSAGE);
    }
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  methods: {
    /**
     * Check, that user fill all fields
     * @return {Boolean}
     */
    canCreateAccount() {
      return (
        !!this.emailToRead &&
        !!this.userFirstName &&
        !!this.userLastName &&
        !!this.password &&
        this.termsAndConditions &&
        !this.validation.hasError("password")
      );
    },

    /**
     * Create account
     * @return {Promise<void>}
     */
    async createAccount() {
      if (!this.canCreateAccount()) {
        return;
      }

      let { success, messages, errors, user } = await this.$store.dispatch("users/createAccount", {
        email: this.emailToRead,
        firstName: this.userFirstName,
        lastName: this.userLastName,
        password: this.password
      });

      this.showMessages(messages);
      this.showErrors(errors);

      if (success && user) {
        await this.redirectUser(user);
      }
    }
  }
};
</script>
